import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { getStepRange, processRawValue } from '@atlaskit/editor-common/utils';
import { Fragment } from '@atlaskit/editor-prosemirror/model';
import { getBreakoutMode } from './node-width';
export { isInEmptyLine } from '@atlaskit/editor-common/utils';
export function processRawFragmentValue(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
  if (!value) {
    return;
  }
  var adfEntities = value.map(function (item) {
    return processRawValue(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent);
  }).filter(function (item) {
    return Boolean(item);
  });
  if (adfEntities.length === 0) {
    return;
  }
  return Fragment.from(adfEntities);
}
export function nodesBetweenChanged(tr, f, startPos) {
  var stepRange = getStepRange(tr);
  if (!stepRange) {
    return;
  }
  tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
export function getNodesCount(node) {
  var count = {};
  node.nodesBetween(0, node.nodeSize - 2, function (node) {
    count[node.type.name] = (count[node.type.name] || 0) + 1;
  });
  return count;
}

/**
 * Returns a set of active child breakout modes
 */
export function getChildBreakoutModes(doc, schema) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['wide', 'full-width'];
  var breakoutModes = new Set();
  if (doc.type.name === 'doc' && doc.childCount) {
    for (var i = 0; i < doc.childCount; ++i) {
      if (breakoutModes.size === filter.length) {
        break;
      }
      var breakoutMode = getBreakoutMode(doc.child(i), schema.marks.breakout);
      if (breakoutMode && filter.includes(breakoutMode)) {
        breakoutModes.add(breakoutMode);
      }
    }
  }
  return _toConsumableArray(breakoutModes);
}